export const languages = {
  ar: { isoCode: "ar", name: "عربي" },
  en: { isoCode: "en", name: "English" },
  fr: { isoCode: "fr", name: "French" },
  af: { isoCode: "af", name: "Afrikaans" },
  sq: { isoCode: "sq", name: "Albanian" },
  am: { isoCode: "am", name: "Amharic" },
  hy: { isoCode: "hy", name: "Armenian" },
  az: { isoCode: "az", name: "Azerbaijani" },
  eu: { isoCode: "eu", name: "Basque" },
  be: { isoCode: "be", name: "Belarusian" },
  bn: { isoCode: "bn", name: "Bengali" },
  bs: { isoCode: "bs", name: "Bosnian" },
  bg: { isoCode: "bg", name: "Bulgarian" },
  ca: { isoCode: "ca", name: "Catalan" },
  co: { isoCode: "co", name: "Corsican" },
  hr: { isoCode: "hr", name: "Croatian" },
  cs: { isoCode: "cs", name: "Czech" },
  da: { isoCode: "da", name: "Danish" },
  nl: { isoCode: "nl", name: "Dutch" },
  eo: { isoCode: "eo", name: "Esperanto" },
  et: { isoCode: "et", name: "Estonian" },
  fi: { isoCode: "fi", name: "Finnish" },
  fy: { isoCode: "fy", name: "Frisian" },
  gl: { isoCode: "gl", name: "Galician" },
  ka: { isoCode: "ka", name: "Georgian" },
  de: { isoCode: "de", name: "German" },
  el: { isoCode: "el", name: "Greek" },
  gu: { isoCode: "gu", name: "Gujarati" },
  ha: { isoCode: "ha", name: "Hausa" },
  he: { isoCode: "he", name: "Hebrew" },
  hi: { isoCode: "hi", name: "Hindi" },
  hu: { isoCode: "hu", name: "Hungarian" },
  is: { isoCode: "is", name: "Icelandic" },
  ig: { isoCode: "ig", name: "Igbo" },
  id: { isoCode: "id", name: "Indonesian" },
  ga: { isoCode: "ga", name: "Irish" },
  it: { isoCode: "it", name: "Italian" },
  ja: { isoCode: "ja", name: "Japanese" },
  jv: { isoCode: "jv", name: "Javanese" },
  kn: { isoCode: "kn", name: "Kannada" },
  kk: { isoCode: "kk", name: "Kazakh" },
  km: { isoCode: "km", name: "Khmer" },
  ko: { isoCode: "ko", name: "Korean" },
  ku: { isoCode: "ku", name: "Kurdish" },
  ky: { isoCode: "ky", name: "Kyrgyz" },
  lo: { isoCode: "lo", name: "Lao" },
  la: { isoCode: "la", name: "Latin" },
  lv: { isoCode: "lv", name: "Latvian" },
  lt: { isoCode: "lt", name: "Lithuanian" },
  lb: { isoCode: "lb", name: "Luxembourgish" },
  mk: { isoCode: "mk", name: "Macedonian" },
  mg: { isoCode: "mg", name: "Malagasy" },
  ms: { isoCode: "ms", name: "Malay" },
  ml: { isoCode: "ml", name: "Malayalam" },
  mt: { isoCode: "mt", name: "Maltese" },
  mi: { isoCode: "mi", name: "Maori" },
  mr: { isoCode: "mr", name: "Marathi" },
  mn: { isoCode: "mn", name: "Mongolian" },
  ne: { isoCode: "ne", name: "Nepali" },
  no: { isoCode: "no", name: "Norwegian" },
  ps: { isoCode: "ps", name: "Pashto" },
  fa: { isoCode: "fa", name: "Persian" },
  pl: { isoCode: "pl", name: "Polish" },
  pa: { isoCode: "pa", name: "Punjabi" },
  ro: { isoCode: "ro", name: "Romanian" },
  ru: { isoCode: "ru", name: "Russian" },
  sm: { isoCode: "sm", name: "Samoan" },
  sr: { isoCode: "sr", name: "Serbian" },
  st: { isoCode: "st", name: "Sesotho" },
  sn: { isoCode: "sn", name: "Shona" },
  sd: { isoCode: "sd", name: "Sindhi" },
  sk: { isoCode: "sk", name: "Slovak" },
  sl: { isoCode: "sl", name: "Slovenian" },
  so: { isoCode: "so", name: "Somali" },
  es: { isoCode: "es", name: "Spanish" },
  su: { isoCode: "su", name: "Sundanese" },
  sw: { isoCode: "sw", name: "Swahili" },
  sv: { isoCode: "sv", name: "Swedish" },
  tg: { isoCode: "tg", name: "Tajik" },
  ta: { isoCode: "ta", name: "Tamil" },
  te: { isoCode: "te", name: "Telugu" },
  th: { isoCode: "th", name: "Thai" },
  tr: { isoCode: "tr", name: "Turkish" },
  uk: { isoCode: "uk", name: "Ukrainian" },
  ur: { isoCode: "ur", name: "Urdu" },
  uz: { isoCode: "uz", name: "Uzbek" },
  vi: { isoCode: "vi", name: "Vietnamese" },
  cy: { isoCode: "cy", name: "Welsh" },
  xh: { isoCode: "xh", name: "Xhosa" },
  yi: { isoCode: "yi", name: "Yiddish" },
  yo: { isoCode: "yo", name: "Yoruba" },
  zu: { isoCode: "zu", name: "Zulu" },
  pt: { isoCode: "pt", name: "Portuguese" },
  "zh-CN": { isoCode: "zh-CN", name: "Chinese (Simplified)" },
  "zh-TW": { isoCode: "zh-TW", name: "Chinese (Traditional)" },
};
